<template>
  <v-dialog
    v-model="active"
    @click:outside="$emit('close')"
    width="700"
  >
    <v-card style="padding:20px 50px">
      <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
      <v-card-title class="d-flex justify-content-center">
        <h4  style="color:var(--medium-blue)"> <i class="mdi mdi-alert"></i> Este animal está com parto aberto!</h4> 
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="Object.keys(openBirth).length > 0">
        <p>Para lançar um novo parto na {{openBirth.name}}, por favor encerre o último parto <strong>{{openBirth.last_birthday}}</strong></p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name:"ModalAlert",
  props:{
    active:Boolean,
    openBirth:Object
  }
}
</script>

<style scoped>
  .close-icon {
    right: 10px;
    top: 10px;
    position: absolute;
    font-size: 1.3rem;
    cursor: pointer;
  }
</style>
